import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {AppBar, Box, Button, MenuItem, styled, Toolbar, Tooltip} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {Container} from "@material-ui/core"
import {masqueradeQuit} from "../../../actions";
import BBIconUserAnonymous from "../../../assets/bbCustomIcons/BBIconUserAnonymous";


const MasqueradeToolbar = (props) => {

    // const authUser = useSelector(({auth}) => auth.authUser);
    const {authUser, tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade} = useSelector(({auth}) => auth);

    const dispatch = useDispatch();

    const handleMasqueradeQuit = () => {
        dispatch(masqueradeQuit(tokenOfAdminDuringMasquerade, refreshTokenOfAdminDuringMasquerade))
    }



    if(tokenOfAdminDuringMasquerade && refreshTokenOfAdminDuringMasquerade) {
        return <>
            {/*<AppBar position="absolute" sx={{ top: 'auto', bottom: 0 }}>*/}
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    {/*<Typography*/}
                    {/*    variant="h6"*/}
                    {/*    noWrap*/}
                    {/*    component="div"*/}
                    {/*    sx={{ mr: 2, display: { xs: 'none', md: 'flex' } }}*/}
                    {/*>*/}
                    {/*    LOGO*/}
                    {/*</Typography>*/}

                    {/*<Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>*/}
                    {/*    <IconButton*/}
                    {/*        size="large"*/}
                    {/*        aria-label="account of current user"*/}
                    {/*        aria-controls="menu-appbar"*/}
                    {/*        aria-haspopup="true"*/}
                    {/*        onClick={handleOpenNavMenu}*/}
                    {/*        color="inherit"*/}
                    {/*    >*/}
                    {/*        <MenuIcon />*/}
                    {/*    </IconButton>*/}
                        {/*<Menu*/}
                        {/*    id="menu-appbar"*/}
                        {/*    anchorEl={anchorElNav}*/}
                        {/*    anchorOrigin={{*/}
                        {/*        vertical: 'bottom',*/}
                        {/*        horizontal: 'left',*/}
                        {/*    }}*/}
                        {/*    keepMounted*/}
                        {/*    transformOrigin={{*/}
                        {/*        vertical: 'top',*/}
                        {/*        horizontal: 'left',*/}
                        {/*    }}*/}
                        {/*    open={Boolean(anchorElNav)}*/}
                        {/*    onClose={handleCloseNavMenu}*/}
                        {/*    sx={{*/}
                        {/*        display: { xs: 'block', md: 'none' },*/}
                        {/*    }}*/}
                        {/*>*/}
                        {/*    {pages.map((page) => (*/}
                        {/*        <MenuItem key={page} onClick={handleCloseNavMenu}>*/}
                        {/*            <Typography textAlign="center">{page}</Typography>*/}
                        {/*        </MenuItem>*/}
                        {/*    ))}*/}
                        {/*</Menu>*/}
                    {/*</Box>*/}
                    {/*<Typography*/}
                    {/*    variant="h6"*/}
                    {/*    noWrap*/}
                    {/*    component="div"*/}
                    {/*    sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}*/}
                    {/*>*/}
                    {/*    LOGO*/}
                    {/*</Typography>*/}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <Tooltip title={`You are currently masquerading as ${(authUser && authUser.user) ? `${authUser.user.username}` : "Loading..."}`}>
                            <span>
                                <BBIconUserAnonymous />
                            </span>
                        </Tooltip>

                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                        <Tooltip title={"Exit the masquerade and return to your admin account."}>
                            <span>
                            <Button
                                variant="contained"
                                size={"small"}
                                color="secondary"
                                // className={}
                                // onClick={}
                                // disabled={}
                                // className={"text-electric-blue"}
                                // key={page}
                                onClick={handleMasqueradeQuit}
                                // sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                Quit Masquerade
                            </Button>
                            </span>
                        </Tooltip>
                    </Box>

                    {/*<Box sx={{ flexGrow: 0 }}>*/}
                    {/*    <Tooltip title="Open settings">*/}
                    {/*        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>*/}
                    {/*            <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />*/}
                    {/*        </IconButton>*/}
                    {/*    </Tooltip>*/}
                    {/*    <Menu*/}
                    {/*        sx={{ mt: '45px' }}*/}
                    {/*        id="menu-appbar"*/}
                    {/*        anchorEl={anchorElUser}*/}
                    {/*        anchorOrigin={{*/}
                    {/*            vertical: 'top',*/}
                    {/*            horizontal: 'right',*/}
                    {/*        }}*/}
                    {/*        keepMounted*/}
                    {/*        transformOrigin={{*/}
                    {/*            vertical: 'top',*/}
                    {/*            horizontal: 'right',*/}
                    {/*        }}*/}
                    {/*        open={Boolean(anchorElUser)}*/}
                    {/*        onClose={handleCloseUserMenu}*/}
                    {/*    >*/}
                    {/*        {settings.map((setting) => (*/}
                    {/*            <MenuItem key={setting} onClick={handleCloseNavMenu}>*/}
                    {/*                <Typography textAlign="center">{setting}</Typography>*/}
                    {/*            </MenuItem>*/}
                    {/*        ))}*/}
                    {/*    </Menu>*/}
                    {/*</Box>*/}
                </Toolbar>
            </Container>
        {/*</AppBar>*/}
</>
    } else {
        return null
    }

    // return <div>Test</div>

}
export default MasqueradeToolbar;
